import styled from 'styled-components'

export const Fieldset = styled.fieldset`
  display: flex;
  justify-content: space-between;
`
